const POSITION_LABELS: Record<string, string> = {
  BOD: "Board of Directors",
  BRDLIASN: "Board Liaison",
  CHAIR: "Chairperson",
  COCHAIR: "Co-Chair",
  INCBOD: "Incoming Board of Directors",
  INDRCTR: "Independent Director",
  INDV: "Individual",
  STAFF: "Staff Liaison",
  COUNSEL: "Counsel",
  HNPRES: "Honorary President",
  OFFICER: "Officer",
  PLYER: "Player Director",
  VCHAIR: "Vice Chair"
};

const DISTRICT_POSITION_PATTERN = /^DIST(\d{2})$/;

export function formatPosition(position: string | null | undefined) {
  if (!position) return "Individual";

  const normalizedPosition = position
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
  const compactPosition = normalizedPosition.replace(/_/g, "");
  const districtMatch = compactPosition.match(DISTRICT_POSITION_PATTERN);
  if (districtMatch) return `Director District ${Number(districtMatch[1])}`;

  return POSITION_LABELS[normalizedPosition] ?? "Individual";
}
